import {AirDataPollActions, AirDataPollActionTypes} from '../actions/air-data-poll.actions';
import {PolledAirDatum} from '../models/air-data';

export interface State {
  entities: { [deviceUuid: string]: PolledAirDatum };
  isAirDataPolling: boolean;
}

export const initialState: State = {
  entities: {},
  isAirDataPolling: false
};

export function reducer(state = initialState, action: AirDataPollActions): State {
  switch (action.type) {

    case AirDataPollActionTypes.StartAirDataPoll: {
      return {
        ...state,
        isAirDataPolling: true
      };
    }

    case AirDataPollActionTypes.UpsertPolledAirData: {
      const polledAirData: PolledAirDatum[] = action.payload;
      const entities = polledAirData.reduce((acc: { [deviceUuid: string]: PolledAirDatum }, polledAirDatum: PolledAirDatum) => {
        return {
          ...acc,
          [polledAirDatum.deviceUuid]: polledAirDatum
        };
      }, {});

      return {
        ...state,
        entities,
        isAirDataPolling: true
      };
    }

    case AirDataPollActionTypes.StopAirDataPoll: {
      return {
        ...state,
        isAirDataPolling: false
      };
    }

    default:
      return state;
  }
}

export const airDataPollEntities = (state: State) => state.entities;
export const isAirDataPolling = (state: State) => state.isAirDataPolling;
